import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { auth } from '@hobs/auth/reducer';
import { loadingReducer as loading } from '@hobs/utils/loading';
import attachment from '@hobs/reducers/attachment';
import odata from '@hobs/reducers/odata';
import locations from '@hobs/reducers/locations';
import serviceRequests from '@hobs/reducers/serviceRequests';
import parties from '@hobs/reducers/parties';
import phases from '@hobs/reducers/phases';
import users from '@hobs/reducers/users';
import units from '@hobs/reducers/units';
import cor from '@hobs/reducers/cor';
import discussion from '@hobs/reducers/discussion';
import customServiceRequests from '@hobs/reducers/customServiceRequests';
import assignmentServiceRequest from '@hobs/reducers/assignmentServiceRequest';
import gridSelections from '@hobs/reducers/gridSelections';
import annex from '@hobs/reducers/annex';
import exercises from '@hobs/reducers/exercises';
import exercise from '@hobs/reducers/exercise';
import approvalSummary from '@hobs/reducers/approvalSummary';
import transportation from '@hobs/reducers/transportation';
import mealPlanner from '@hobs/reducers/mealPlanner';
import tickets from '@hobs/reducers/tickets';
import activity from '@hobs/reducers/activity';
import notifications from '@hobs/reducers/notifications';
import sor from './sor';

export default history =>
  combineReducers({
    auth,
    attachment,
    exercise,
    exercises,
    odata,
    annex,
    router: connectRouter(history),
    loadingBar: loadingBarReducer,
    loading,
    locations,
    serviceRequests,
    units,
    users,
    phases,
    parties,
    sor,
    cor,
    discussion,
    customServiceRequests,
    assignmentServiceRequest,
    gridSelections,
    approvalSummary,
    transportation,
    mealPlanner,
    tickets,
    activity,
    notifications
  });
